module.exports = __webpack_public_path__ + "img/whyJava.eb54dbdf.jpeg";